import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appRecordButtons]',
})
export class RecordButtonsDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
